import { LearningBudgetService } from '@/services/learning-budget';
import { ApiReactMutationOptions } from '@/types/api';
import {
  ILearningBudgetSetup,
  ILearningBudgetUpdatePayload,
} from '@/types/learning-budget';
import { useMutation } from '@tanstack/react-query';

type UpdateLearningBudgetSetupPayload = {
  id: string;
  update: ILearningBudgetUpdatePayload;
};

export function useLearningBudgetSetupUpdateMutation(
  options?: ApiReactMutationOptions<
    ILearningBudgetSetup,
    UpdateLearningBudgetSetupPayload
  >,
) {
  return useMutation({
    mutationKey: [LearningBudgetService.SETUP_PATH, 'update'],
    mutationFn: async ({ id, update }) => {
      const response = await LearningBudgetService.updateLearningBudgetSetup(
        id,
        update,
      );
      return response.data;
    },
    ...options,
  });
}
